import { cloneElement, isValidElement } from 'react';

import { useUrlMapperContext } from '../url-mapper-context/context';

import type { TProps } from './models';

/**
 * Компонент, установки URL детальной страницы оффера для дочернего виджета, используется с UrlMapperContext
 * */
export const UrlMapper = ({
    children,
    forwardProps = true,
    id,
    propNames,
    ...proxyProps
}: TProps) => {
    const urlMap = useUrlMapperContext();

    const transitProps = forwardProps ? proxyProps : {};
    let overrideProps = {};

    if (id && urlMap[id]) {
        overrideProps = propNames.reduce(
            (res, propName) => ({ ...res, [propName]: urlMap[id] }),
            {}
        );
    }

    return isValidElement(children)
        ? cloneElement(children, {
              ...transitProps,
              ...overrideProps,
          })
        : children;
};
